"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateToResponses = void 0;
const lodash_1 = require("lodash");
const utils_1 = require("../../utils");
const guards_1 = require("../guards");
const content_1 = require("./content");
function translateToResponse(document, response, statusCode) {
    const resolvedResponse = utils_1.maybeResolveLocalRef(document, response);
    if (!guards_1.isResponseObject(resolvedResponse))
        return;
    const dereferencedHeaders = lodash_1.reduce(resolvedResponse.headers, (result, header, name) => {
        return Object.assign(Object.assign({}, result), { [name]: utils_1.maybeResolveLocalRef(document, header) });
    }, {});
    return {
        code: statusCode,
        description: resolvedResponse.description,
        headers: lodash_1.compact(lodash_1.map(dereferencedHeaders, content_1.translateHeaderObject)),
        contents: lodash_1.compact(lodash_1.map(resolvedResponse.content, lodash_1.partial(content_1.translateMediaTypeObject, document))),
    };
}
function translateToResponses(document, responses) {
    if (!utils_1.isDictionary(responses)) {
        return [];
    }
    return lodash_1.compact(lodash_1.map(responses, lodash_1.partial(translateToResponse, document)));
}
exports.translateToResponses = translateToResponses;
//# sourceMappingURL=responses.js.map